module.exports = __webpack_public_path__ + "img/2695-4.35d89d0d.png";